import { InvoiceDeliveryTypeEnum } from "@api/index";

export const InvoiceDeliveryTypeTranslations = {
  [InvoiceDeliveryTypeEnum.Mail]: 'global.letter',
  [InvoiceDeliveryTypeEnum.Email]: 'global.email'
};
